import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {
    setCurrentSemester,
    setDepartmentsList,
    setFacultyList,
    setLoginDetails,
    setPermissionDetails
} from "../../../actions/actions";
import {useNavigate} from "react-router";
import {projectLogo} from "../../../resources/constants";
import axios from "axios";
import {serverLink} from "../../../resources/url";
import { Link, useLocation } from "react-router-dom";

function Header(props) {
    const token  = props.loginData[0].token;
    const name  = props.loginData[0].student_name;
    const userType  = props.loginData[0].userType;
    const navigate = useNavigate();

    useEffect(() => {
        getFaculty();
    }, []);

    const getFaculty = async () => {
        await axios
            .get(`${serverLink}staff/academics/faculty/list`, token)
            .then((result) => {
                if (result.data.length > 0) {
                    props.setOnFacultyList(result.data);
                }
            });

        await axios
            .get(`${serverLink}staff/academics/department/list`, token)
            .then((result) => {
                if (result.data.length > 0) {
                    props.setOnDepartmentList(result.data);
                }
            });

        axios.get(`${serverLink}staff/settings/dashboard/current_semester`, token)
            .then((result)=>{
                let semester = result.data[0].SemesterCode;
                props.setOnCurrentSemester(semester)
            })
    };

    const signOut = () => {
        props.setOnLoginDetails([]);
        props.setOnPermissionDetails([]);
    };

    return (
        <>
            <div className="header" id="printPageButton">

                <div className="header-left active mt-1">
                    <Link to="/" className="logo logo-normal">
                        <img src={projectLogo} style={{width: '60px', height: '60px'}} alt="Logo"/>
                    </Link>
                    <Link to="/" className="logo-small">
                        <img src={projectLogo} style={{width: '60px', height: '55px'}}  alt="Logo"/>
                    </Link>
                    <Link to="/" className="dark-logo">
                        <img src={projectLogo} style={{width: '60px', height: '60px'}}  alt="Logo"/>
                    </Link>
                    <Link id="toggle_btn" href="#">
                        <i className="ti ti-menu-deep"></i>
                    </Link>
                </div>

                <a id="mobile_btn" className="mobile_btn" href="#sidebar">
				<span className="bar-icon">
					<span></span>
					<span></span>
					<span></span>
				</span>
                </a>

                <div className="header-user">
                    <div className="nav user-menu">

                        <div className="nav-item nav-search-inputs me-auto">
                            <div className="top-nav-search">
                                <a href="" className="responsive-search">
                                    <i className="fa fa-search"></i>
                                </a>
                                <form action="#" className="dropdown">
                                    <div className="searchinputs" id="dropdownMenuClickable">
                                        <input type="text" placeholder="Search"/>
                                            <div className="search-addon">
                                                <button type="submit"><i className="ti ti-command"></i></button>
                                            </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div className="d-flex align-items-center">
                            <div className="pe-1">
                                <a href="#" id="dark-mode-toggle"
                                   className="dark-mode-toggle activate btn btn-outline-light bg-white btn-icon me-1">
                                    <i className="ti ti-moon"></i>
                                </a>
                                <a href="#" id="light-mode-toggle"
                                   className="dark-mode-toggle btn btn-outline-light bg-white btn-icon me-1">
                                    <i className="ti ti-brightness-up"></i>
                                </a>
                            </div>
                            <div className="dropdown ms-1">
                                <a href="#" className="dropdown-toggle d-flex align-items-center"
                                   data-bs-toggle="dropdown">
								<span className="avatar avatar-md rounded">
									<img src={require('../../images/bg/avatar-27.jpg')} alt="Img" className="img-fluid"/>
								</span>
                                </a>
                                <div className="dropdown-menu">
                                    <div className="d-block">
                                        <div className="d-flex align-items-center p-2">
										<span className="avatar avatar-md me-2 online avatar-rounded">
											<img src={require('../../images/bg/avatar-27.jpg')} alt="img"/>
										</span>
                                            <div>
                                                <h6 className="">{name}</h6>
                                                <p className="text-primary mb-0">{userType === 'returning' ? 'Student' : 'Applicant'}</p>
                                            </div>
                                        </div>
                                        <hr className="m-0"/>

                                                <Link className="dropdown-item d-inline-flex align-items-center p-2" to="/"  onClick={signOut}><i
                                                    className="ti ti-login me-2"></i>Logout</Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="dropdown mobile-user-menu">
                    <a href="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown"
                       aria-expanded="false"><i className="fa fa-ellipsis-v"></i></a>
                    <hr className="m-0"/>
                    <div className="dropdown-menu dropdown-menu-end">
                        <Link className="dropdown-item" onClick={signOut} to="/"  >Logout</Link>
                    </div>
                </div>

            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        loginData: state.LoginDetails,
        permissionData: state.permissionData,
        currentSemester: state.currentSemester
    };
};

const mapDisptachToProps = (dispatch) => {
    return {
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
        setOnPermissionDetails: (p) => {
            dispatch(setPermissionDetails(p));
        },
        setOnFacultyList: (p) => {
            dispatch(setFacultyList(p));
        },
        setOnDepartmentList: (p) => {
            dispatch(setDepartmentsList(p));
        },
        setOnCurrentSemester:(p)=>{
            dispatch(setCurrentSemester(p));
        }
    };
};

export default connect(mapStateToProps, mapDisptachToProps)(Header);
